/* Hamak i Ja — header helpers (loaded by sections/header.liquid and sections/hk-benefits-bar.liquid)
   1. <hk-benefits>: on phones the benefits strip is a one-line swipe row that auto-advances.
   2. Desktop dropdowns open on hover too (Dawn opens them on click only). */
(() => {
  if (!customElements.get('hk-benefits')) {
    class HkBenefits extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.hk-benefits__track');
        if (!this.track) return;
        this.delay = Math.max(2, Number(this.dataset.interval) || 4) * 1000;
        this.paused = false;
        this.visible = true;
        const pause = () => { this.paused = true; };
        const resume = () => { this.paused = false; };
        this.addEventListener('pointerenter', pause);
        this.addEventListener('pointerleave', resume);
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', resume);
        this.track.addEventListener('touchstart', () => { this.paused = true; clearTimeout(this.resumeT); }, { passive: true });
        this.track.addEventListener('touchend', () => { clearTimeout(this.resumeT); this.resumeT = setTimeout(resume, this.delay * 1.5); }, { passive: true });
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => { this.visible = entries[0].isIntersecting; });
          this.io.observe(this);
        }
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.timer = setInterval(() => this.tick(), this.delay);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        clearTimeout(this.resumeT);
        if (this.io) this.io.disconnect();
      }
      tick() {
        const t = this.track;
        if (this.paused || !this.visible || this.reduce.matches || document.hidden) return;
        if (t.scrollWidth <= t.clientWidth + 2) return; // everything fits (desktop / tablet)
        const w = t.clientWidth;
        const atEnd = t.scrollLeft + w >= t.scrollWidth - 4;
        t.scrollTo({ left: atEnd ? 0 : t.scrollLeft + w, behavior: atEnd ? 'auto' : 'smooth' });
      }
    }
    customElements.define('hk-benefits', HkBenefits);
  }

  if (window.hkHeaderHover) return;
  window.hkHeaderHover = true;
  const canHover = window.matchMedia('(hover: hover) and (min-width: 990px)');
  const init = () => {
    document.querySelectorAll('.hk-header header-menu').forEach((menu) => {
      if (menu.dataset.hkHover) return;
      menu.dataset.hkHover = '1';
      const details = menu.querySelector('details');
      const summary = details && details.querySelector('summary');
      if (!summary) return;
      let t;
      menu.addEventListener('mouseenter', () => {
        if (!canHover.matches) return;
        clearTimeout(t);
        if (!details.open) { details.open = true; summary.setAttribute('aria-expanded', 'true'); }
      });
      menu.addEventListener('mouseleave', () => {
        if (!canHover.matches) return;
        t = setTimeout(() => { details.open = false; summary.setAttribute('aria-expanded', 'false'); }, 160);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* 3. Auto-compact header: on desktop widths, if the menu (any length set by the merchant) does not fit between
      the logo and the icons, switch to the burger layout instead of squeezing/overlapping. */
(() => {
  const init = () => {
    const root = document.querySelector('.hk-header');
    const bar = root && root.querySelector('.hk-header__bar');
    if (!bar || !root.querySelector('.hk-nav')) return;
    const mq = window.matchMedia('(min-width: 990px)');
    const measure = () => {
      root.classList.remove('hk-header--compact');
      if (!mq.matches) return;
      const list = root.querySelector('.hk-nav__list') || root.querySelector('.hk-nav');
      const logo = root.querySelector('.hk-header__logo-img') || root.querySelector('.hk-header__brand');
      const icons = root.querySelector('.hk-header__icons');
      const n = list.getBoundingClientRect();
      const l = logo ? logo.getBoundingClientRect() : { right: n.left };
      let iconsLeft = Infinity;
      if (icons) [...icons.children].forEach((c) => { const r = c.getBoundingClientRect(); if (r.width) iconsLeft = Math.min(iconsLeft, r.left); });
      const overflow = bar.scrollWidth - bar.clientWidth > 1 || n.left < l.right + 16 || n.right > iconsLeft - 16;
      root.classList.toggle('hk-header--compact', overflow);
    };
    let raf = 0;
    const schedule = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(measure); };
    measure();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    window.addEventListener('resize', schedule);
    if (mq.addEventListener) mq.addEventListener('change', schedule);
    window.addEventListener('load', schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();